// extracted by mini-css-extract-plugin
export default {"collapseButton":"DashboardPage_collapseButton__J8+Oy","logo":"DashboardPage_logo__wHU-i","content":"DashboardPage_content__dk64e","menu_items":"DashboardPage_menu_items__PXTL4"};